import React from 'react';

import { ConsentStep } from '../preflight/ConsentStep';
import { ORAL_EXAM_CONSENT_POLICY_VERSION } from '../preflight/OralExamPreFlightSteps';

import type { LobbyStepProps } from './types';

/**
 * Lobby step ① — GDPR-purpose-led consent (student UX §3.2 v1.3 / AC-PF1).
 * Records consent via the real mutation, then advances.
 */
export function LobbyConsentStep({ actions }: LobbyStepProps) {
  const handleAccept = () => {
    actions.recordConsent();
  };

  return (
    <ConsentStep
      onAccept={handleAccept}
      isSubmitting={actions.isRecordingConsent}
      policyVersion={ORAL_EXAM_CONSENT_POLICY_VERSION}
    />
  );
}
